// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.join-btns button[kendoButton] {
  white-space: pre-wrap;
  padding: 15px;
  text-transform: unset;
  font-size: 18px;
  width: 100%;
  color: #0f5597;
  border-radius: 0;
  margin-right: 15px;
  margin-bottom: 25px;
  min-height: 50px;
}
.join-btns .flex-join-buttons {
  display: flex;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/register-join-committee/register-join-committee.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAR;AAGI;EACI,aAAA;EACA,SAAA;AADR","sourcesContent":[".join-btns {\n    button[kendoButton] {\n        white-space: pre-wrap;\n        padding: 15px;\n        text-transform: unset;\n        font-size: 18px;\n        width: 100%;\n        color: #0f5597;\n        border-radius: 0;\n        margin-right: 15px;\n        margin-bottom: 25px;\n        min-height: 50px;\n    }\n\n    .flex-join-buttons{\n        display: flex;\n        gap: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
